import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { translations } from "./i18n";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const Ctx = createContext(null);

// Set auth header synchronously on module load if token exists
const _initialToken = localStorage.getItem("progere_token");
if (_initialToken) axios.defaults.headers.common["Authorization"] = `Bearer ${_initialToken}`;

export const AppProvider = ({ children }) => {
  const [token, setToken] = useState(_initialToken);
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("progere_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [lang, setLang] = useState(() => localStorage.getItem("progere_lang") || "fr");

  useEffect(() => {
    if (token) axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    else delete axios.defaults.headers.common["Authorization"];
  }, [token]);

  useEffect(() => { localStorage.setItem("progere_lang", lang); }, [lang]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    if (data.requires_2fa) {
      return { requires_2fa: true, challenge_id: data.challenge_id, email_hint: data.email_hint };
    }
    localStorage.setItem("progere_token", data.token);
    localStorage.setItem("progere_user", JSON.stringify(data.user));
    setToken(data.token);
    setUser(data.user);
    return data;
  };

  const verify2FA = async (challenge_id, code) => {
    const { data } = await axios.post(`${API}/auth/verify-2fa`, { challenge_id, code });
    localStorage.setItem("progere_token", data.token);
    localStorage.setItem("progere_user", JSON.stringify(data.user));
    setToken(data.token);
    setUser(data.user);
    return data;
  };

  const register = async (payload) => {
    const { data } = await axios.post(`${API}/auth/register`, payload);
    localStorage.setItem("progere_token", data.token);
    localStorage.setItem("progere_user", JSON.stringify(data.user));
    setToken(data.token);
    setUser(data.user);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("progere_token");
    localStorage.removeItem("progere_user");
    setToken(null);
    setUser(null);
  };

  const t = translations[lang];

  return (
    <Ctx.Provider value={{ token, user, lang, setLang, login, verify2FA, register, logout, t, API }}>
      {children}
    </Ctx.Provider>
  );
};

export const useApp = () => useContext(Ctx);
